//           <ModalForm Size="Small:Medium" Size="100px:90%" />

interface Size {
  width: string | undefined
  height: string | undefined
}

interface KnownSizes {
  [key: string]: string
}

const KnownSizes: KnownSizes = {
  Small: '444px',
  Medium: '600px',
  Large: '992px',
}

/**
 * Parses a size string into an object. The format of the string is WIDTH:HEIGHT, where WIDTH and HEIGHT can be
 * any valid CSS size values, such as pixels, percentages, etc. Additionally, predefined sizes like 'Small',
 * 'Medium', and 'Large' can be used for convenience. These predefined sizes can be mixed with standard CSS values.
 *
 * For example, a valid string is: 'Medium:400px'.
 *
 * @param size - The string containing the size in the format WIDTH:HEIGHT.
 * @returns An object with the parsed sizes as 'width' and 'height' properties.
 */

export function parseSize(size: string | undefined) {
  const result: Size = { width: undefined, height: undefined }

  if (size?.toLowerCase() === 'fullscreen') {
    return {
      height: '100dvh',
      width: '100dvw',
    } as Size
  }

  const splitted = (size ?? '').split(':')
  if (splitted.length == 2) {
    result.width = splitted[0]
    result.height = splitted[1]

    if (KnownSizes[splitted[0]]) {
      result.width = KnownSizes[splitted[0]]
    }

    if (KnownSizes[splitted[1]]) {
      result.height = KnownSizes[splitted[1]]
    }
  }
  return result
}
